import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Bee from '@mailupinc/bee-plugin';
import EventBusService, {
  INSERT_LIQUID,
  LIQUID_ENABLED_FIELD_FOCUS_IN,
  LIQUID_ENABLED_FIELD_FOCUS_OUT,
} from 'cio/services/event-bus';
import AuthService from 'cio/services/auth';
import { ActionComposerArgs } from 'cio/components/action-composer';
import { MergeTag } from 'cio/utils/editor-utils';
import { Preview } from 'cio/utils/previews';

export type ActionComposerEditorArgs = Pick<
  ActionComposerArgs,
  'editableEntity' | 'editorName' | 'hasReadOnlyPermission'
> & {
  preview: Preview;
  errors: any;
  isDirty: boolean;
  isPreviewLoading: boolean;

  // Specifically for the drag-and-drop editor
  mergeTags: MergeTag[];
  hasLoadedMergeData: boolean;
  onBeeInit?: (bee: Bee) => void;
};

type ActionComposerEditorSignature = {
  Args: ActionComposerEditorArgs;
};

export type FieldName = 'template.to' | 'template.body';

export default abstract class ActionComposerEditor<
  T extends ActionComposerEditorSignature = ActionComposerEditorSignature,
> extends Component<T> {
  @service auth!: AuthService;
  @service eventBus!: EventBusService;
  @service store!: DS.Store;

  insertLiquid?([fieldName, index]: [FieldName, number], liquid: string, fallback?: string): void;

  @action
  subscribeToLiquid() {
    if (this.insertLiquid == null) {
      return;
    }

    this.eventBus.subscribe(INSERT_LIQUID, this, this.insertLiquid);
  }

  @action
  unsubscribeFromLiquid() {
    if (this.insertLiquid == null) {
      return;
    }

    this.eventBus.unsubscribe(INSERT_LIQUID, this, this.insertLiquid);
  }

  @action
  liquidFieldFocusIn(fieldName: string, index = 0) {
    this.eventBus.publish(LIQUID_ENABLED_FIELD_FOCUS_IN, [fieldName, index]);
  }

  @action
  liquidFieldFocusOut() {
    this.eventBus.publish(LIQUID_ENABLED_FIELD_FOCUS_OUT);
  }
}
